var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgShieldOrange = function SvgShieldOrange(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 80 80"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#shield-orange_svg__a)",
    d: "m40.5 80-1.276-.743c-5.487-3.198-10.39-6.461-14.572-9.7a43.16 43.16 0 0 1-12.267-15.065A43.331 43.331 0 0 1 8 35.55V14.546a2.54 2.54 0 0 1 2.13-2.506C23.888 9.795 39.054.86 39.206.77a2.536 2.536 0 0 1 2.589 0c.15.089 15.317 9.025 29.075 11.27A2.54 2.54 0 0 1 73 14.546v21.003c0 6.53-1.517 13.081-4.385 18.943a43.15 43.15 0 0 1-12.266 15.065c-4.183 3.239-9.086 6.502-14.573 9.699l-1.276.743Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M26 40.081 35.948 50 57 29"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "shield-orange_svg__a",
    x1: 73.794,
    x2: 7.966,
    y1: 38.764,
    y2: 38.867,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5BE60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5BE60",
    stopOpacity: 0.2
  })))));
};
export default SvgShieldOrange;